export enum CouponType {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT_IN_CENTS = "AMOUNT_IN_CENTS",
}
